import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-phone-register-engine-error-message',
  templateUrl: './sales-phone-register-engine-error-message.component.html'
})

export class SalesPhoneRegisterEngineErrorMessageComponent {
  visible = false;
}
